import React from "react";
import { prog1 } from "../../../assets";
import { numberFormat } from "../../../helpers/numberFormat";
import { numberToDate } from "../../../helpers/numberToDate";
import parser from "html-react-parser";

const DetailProgramComp = (props) => {
  // console.log(props.program)
  return (
    <>
      <div style={{ margin: "auto", textAlign: "center", marginBottom: "3%" }}>
        <img src={props.program.coverLink} alt="prog1" width="55%" />
      </div>
      <div style={{ margin: "auto", marginBottom: "3%" }}>
        <h3 className="mb-1">Nama Program :</h3>
        <ul className="mb-3" style={{ fontSize: "14px", fontWeight: "400" }}>
          {<li>{props.program.name}</li>}
        </ul>
        <h3 className="mb-1">Type Program :</h3>
        <ul className="mb-3" style={{ fontSize: "14px", fontWeight: "400" }}>
          {
            <li>
              <span
                class="badge"
                style={{ backgroundColor: "#0C86D9", color: "#F2F2F2" }}
              >
                {props.program.type}
              </span>
            </li>
          }
        </ul>
        <h3 className="mb-1">Jadwal Program :</h3>
        <ul className="mb-3" style={{ fontSize: "14px", fontWeight: "400" }}>
          {props.program.Schedules.map((schedule, j) => (
            <li>
              {numberToDate(schedule.startDate)} s/d{" "}
              {numberToDate(schedule.endDate)}
            </li>
          ))}
        </ul>
        <h3 className="mb-1">Harga Program :</h3>
        <ul className="mb-3">
          <li>
            <p
              style={{ fontSize: "14px", color: "#0C86D9", fontWeight: "600" }}
            >
              Rp. {numberFormat(props.program?.Pricebooks[0].price)}
            </p>
            <p style={{ fontStyle: "italic", fontSize: "12px" }}>
              * dikenakan PPN 12%
            </p>
          </li>
        </ul>
      </div>
      <div className="row mb-3">
        <h3 className="mb-3">Deskripsi Program :</h3>
        <p style={{ textAlign: "justify" }}>
          {parser(props?.program?.description)}
        </p>
      </div>
    </>
  );
};

export default DetailProgramComp;
